import keyMirror from 'keymirror';

/**
 * Names for each state of the stage size toggle
 * @enum {string}
 */
const STAGE_SIZE_MODES = keyMirror({
    /**
     * The "large stage" button is pressed; the user would like a large stage.
     */
    large: null,

    /**
     * The "small stage" button is pressed; the user would like a small stage.
     */
    small: null
});

/**
 * Names for each stage render size
 * @enum {string}
 */
const STAGE_DISPLAY_SIZES = keyMirror({
    /**
     * Large stage with wide browser
     */
    large: null,

    /**
     * Large stage with narrow browser
     */
    largeConstrained: null,

    /**
     * Small stage (ignores browser width)
     */
    small: null,

    /**
     * Larger stage used by Alyd Therapy clinician mode
     */
    therapy: null,

    /**
     * Larger stage used by Alyd Therapy Student View
     * on normal laptop/desktop displays
     */
    therapyStudent: null,

    /**
     * Alyd Therapy Student View on large desktop / HD displays
     */
    therapyStudentLarge: null,

    /**
     * Alyd Therapy Student View on standard tablets
     * (iPad Mini/Air/Pro 11")
     */
    therapyStudentTablet: null,

    /**
     * Alyd Therapy Student View fallback for phones / very small viewports
     */
    therapyStudentSmall: null
});

// Zoom level to start with
const BLOCKS_DEFAULT_SCALE = 0.675;

const STAGE_DISPLAY_SCALES = {};

// Standard Scratch stage sizes
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.large] = 1;
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.largeConstrained] = 0.85;
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.small] = 0.5;

// Alyd Therapy clinician view
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.therapy] = 1.6; // 768x576

// Alyd Therapy Student View
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.therapyStudentLarge] = 2.2; // 1056x792
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.therapyStudent] = 1.8; // 864x648
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.therapyStudentTablet] = 1.4; // 672x504
STAGE_DISPLAY_SCALES[STAGE_DISPLAY_SIZES.therapyStudentSmall] = 1.1; // 528x396

export default {
    standardStageWidth: 480,
    standardStageHeight: 360,
    fullSizeMinWidth: 1096,
    fullSizePaintMinWidth: 1250
};

export {
    BLOCKS_DEFAULT_SCALE,
    STAGE_DISPLAY_SCALES,
    STAGE_DISPLAY_SIZES,
    STAGE_SIZE_MODES
};